import { AccountListItem, ListContentIsland } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { TransferBeneficiaryListItem } from './TransferBeneficiaryListItem';
import { TransferFormValues } from './types';
import { UseFormReturn } from 'react-hook-form';
import {
  ApiAccount,
  ApiExternalOutgoingTransferCreateResponse,
  ApiExternalOutgoingTransferIntentResponse,
} from '../../../openapi';
import { OutgoingTransferBreakdown } from '../../TransferBreakdown/OutgoingTransferBreakdown';
import { useMemo } from 'react';
import { ChallengeRequired, TransferChallengeSuccess } from './TransferChallenge';

export function TransferConfirmStep({
  form,
  accounts,
  intent,
  challenge,
}: {
  form: UseFormReturn<TransferFormValues>;
  accounts: ApiAccount[];
  intent: ApiExternalOutgoingTransferIntentResponse | undefined;
  challenge: ApiExternalOutgoingTransferCreateResponse | undefined;
}) {
  const { t } = useTranslation();
  const accountId = form.watch('accountId');
  const beneficiary = form.watch('beneficiary');
  const account = useMemo(() => accounts.find(({ id }) => id === accountId), [accounts, accountId]);

  switch (challenge?.type) {
    case 'CHALLENGE_REQUIRED':
      return (
        <>
          <ChallengeRequired entity={t('transfer')} challenge={challenge} />
          <ListContentIsland title={t('From')}>
            {account ? <AccountListItem account={account} /> : null}
          </ListContentIsland>
          <OutgoingTransferBreakdown variant="confirm" intent={intent} />
          <ListContentIsland title={t('To')}>
            <TransferBeneficiaryListItem beneficiary={beneficiary} />
          </ListContentIsland>
        </>
      );
    case 'CHALLENGES_COMPLETED':
      return <TransferChallengeSuccess challenge={challenge} />;
    default:
      return null;
  }
}
